import * as Plotly from 'plotly.js/dist/plotly.js';

/**
 * Purge every Plotly chart rendered inside `root` (and `root` itself if it is a
 * chart). Call this from a component's `ngOnDestroy` so Plotly cancels its
 * in-flight auto-margin / relayout passes and frees the graph div — otherwise
 * those async callbacks fire on a torn-down node and throw
 * "Cannot read properties of undefined (reading '_redrawFromAutoMarginCount')"
 * (and similar) as unhandled rejections.
 *
 * Plotly tags every rendered chart element with the `js-plotly-plot` class, so
 * this works regardless of how many charts the component draws or which element
 * ids / refs it used. At `ngOnDestroy` time the component's host element is
 * still attached, so its chart descendants are still queryable.
 */
export function purgePlotlyCharts(root: HTMLElement | null | undefined): void {
	if (!root || typeof root.querySelectorAll !== 'function') {
		return;
	}
	const charts: HTMLElement[] = [];
	if (root.classList?.contains('js-plotly-plot')) {
		charts.push(root);
	}
	root.querySelectorAll('.js-plotly-plot').forEach((el: Element) => charts.push(el as HTMLElement));
	charts.forEach(el => {
		try {
			Plotly.purge(el);
		} catch {
			// Already torn down / never fully initialised — nothing to clean up.
		}
	});
}
